import { jsx as a } from "react/jsx-runtime";
import { createContext as T, forwardRef as s, useContext as f, useMemo as c } from "react";
import { faXmark as F } from "@fortawesome/pro-regular-svg-icons";
import { faInfoCircle as j, faShieldExclamation as k, faShieldXmark as B, faCheckCircle as P } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as g } from "@fortawesome/react-fontawesome";
import * as o from "@radix-ui/react-alert-dialog";
import { Button as m } from "../button/Button.js";
import { twMerge as i } from "tailwind-merge";
const u = T({
  type: "info"
}), R = ({ type: e = "info", children: t, ...r }) => {
  const l = c(() => ({ type: e }), [e]);
  return /* @__PURE__ */ a(o.Root, { ...r, children: /* @__PURE__ */ a(u.Provider, { value: l, children: t }) });
}, p = s(
  ({ className: e = "", ...t }, r) => /* @__PURE__ */ a(
    o.Content,
    {
      ref: r,
      className: i(
        "z-pentOutermost fixed left-[50%] top-[50%] flex w-[90%] max-w-sm -translate-x-[50%] -translate-y-[50%] flex-col gap-y-4 rounded-xl bg-white p-6 shadow-lg",
        "radix-state-open:animate-dialogIn radix-state-closed:animate-dialogOut",
        e
      ),
      onOpenAutoFocus: (l) => {
        var n;
        l.preventDefault(), (n = l.target) == null || n.focus();
      },
      ...t
    }
  )
);
p.displayName = o.Content.displayName;
const y = s(
  ({ className: e, ...t }, r) => /* @__PURE__ */ a("div", { ref: r, className: i("flex flex-col gap-y-1", e), ...t })
);
y.displayName = "AlertDialogBody";
const x = s(
  ({ className: e = "", ...t }, r) => /* @__PURE__ */ a(
    o.Description,
    {
      ref: r,
      className: i("text-base text-gray-600", e),
      ...t
    }
  )
);
x.displayName = o.Description.displayName;
const N = s(
  ({ className: e, ...t }, r) => /* @__PURE__ */ a(
    o.Title,
    {
      ref: r,
      className: i("text-xl font-medium", e),
      ...t
    }
  )
);
N.displayName = o.Title.displayName;
const A = s(
  ({ className: e, ...t }, r) => /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: i("flex justify-between gap-4 pt-4", e),
      ...t
    }
  )
);
A.displayName = "AlertDialogActionFooter";
const D = s(
  ({ className: e, ...t }, r) => /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: i("flex items-center justify-between", e),
      ...t
    }
  )
);
D.displayName = "AlertDialogHeader";
const C = s(
  ({ className: e, "aria-label": t, ...r }, l) => /* @__PURE__ */ a(o.Cancel, { ref: l, asChild: !0, children: /* @__PURE__ */ a(
    m,
    {
      variant: "transparent",
      color: "neutral",
      shape: "square",
      className: i("absolute right-3.5 top-3.5", e),
      "aria-label": t ?? "Close",
      ...r,
      children: /* @__PURE__ */ a(g, { size: "lg", icon: F })
    }
  ) })
);
C.displayName = o.Cancel.displayName;
const h = s(
  ({ className: e, children: t, ...r }, l) => {
    const { type: n } = f(u), d = n === "error" ? "error" : "primary";
    return /* @__PURE__ */ a(o.Action, { ref: l, asChild: !0, children: /* @__PURE__ */ a(
      m,
      {
        variant: "solid",
        color: d,
        className: i("flex-1", e),
        ...r,
        children: t
      }
    ) });
  }
);
h.displayName = o.Action.displayName;
const b = s(
  ({ className: e, children: t, ...r }, l) => /* @__PURE__ */ a(o.Cancel, { ref: l, asChild: !0, children: /* @__PURE__ */ a(
    m,
    {
      variant: "outline",
      color: "neutral",
      className: i("flex-1", e),
      ...r,
      children: t
    }
  ) })
);
b.displayName = o.Cancel.displayName;
const v = s(
  ({ className: e, customIcon: t, ...r }, l) => {
    const { type: n } = f(u), d = c(() => {
      switch (n) {
        case "success":
          return P;
        case "error":
          return B;
        case "warning":
          return k;
        case "info":
        default:
          return j;
      }
    }, [n]), O = c(() => {
      switch (n) {
        case "success":
          return "bg-green-100";
        case "error":
          return "bg-red-100";
        case "warning":
          return "bg-orange-100";
        case "info":
        default:
          return "bg-blue-100";
      }
    }, [n]), I = c(() => {
      switch (n) {
        case "success":
          return "text-green-500";
        case "error":
          return "text-red-500";
        case "warning":
          return "text-orange-500";
        case "info":
        default:
          return "text-blue-500";
      }
    }, [n]);
    return /* @__PURE__ */ a(
      "div",
      {
        ref: l,
        className: i(
          "relative flex aspect-square h-10 items-center justify-center rounded-full",
          e,
          O
        ),
        ...r,
        children: /* @__PURE__ */ a(g, { icon: t ?? d, className: I })
      }
    );
  }
);
v.displayName = "AlertDialogIcon";
const w = s(
  ({ className: e, ...t }, r) => /* @__PURE__ */ a(o.AlertDialogOverlay, { ref: r, asChild: !0, ...t, children: /* @__PURE__ */ a(
    "div",
    {
      className: i(
        "z-pentOutermost fixed inset-0 bg-black bg-opacity-50",
        "radix-state-open:animate-fadeIn radix-state-closed:animate-fadeOut",
        e
      )
    }
  ) })
);
w.displayName = o.AlertDialogOverlay.displayName;
const z = o.Portal, H = o.Trigger, K = R, L = z, Q = p, U = y, V = w, W = H, Y = N, Z = x, _ = h, $ = D, ee = A, te = b, re = C, ae = v;
export {
  _ as Action,
  h as AlertDialogAction,
  A as AlertDialogActionFooter,
  y as AlertDialogBody,
  b as AlertDialogCancel,
  p as AlertDialogContent,
  x as AlertDialogDescription,
  D as AlertDialogHeader,
  v as AlertDialogIcon,
  w as AlertDialogOverlay,
  z as AlertDialogPortal,
  R as AlertDialogRoot,
  N as AlertDialogTitle,
  H as AlertDialogTrigger,
  U as Body,
  te as Cancel,
  re as Close,
  Q as Content,
  Z as Description,
  ee as Footer,
  $ as Header,
  ae as Icon,
  V as Overlay,
  L as Portal,
  K as Root,
  Y as Title,
  W as Trigger
};
